import { ContactGqlService } from './../dynamics/contact-gql.service'
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUser } from '@ebb-v2/ebb-integration';
import { AuthorizationService } from '../authorization.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGqlService implements AuthorizationService   {
  userKey = 'currentUser';

  constructor(
    private contactService: ContactGqlService) {}

    public getUser(): IUser {
      const fetch = localStorage.getItem(this.userKey);
      const user = JSON.parse(fetch);
      return user;
    }

    public setUser(user: IUser) : void {
      localStorage.setItem(this.userKey, JSON.stringify(user));
    }

    public isContractor(user: IUser) : boolean {
      return user && user.isContractor;
    }

    public isEngineer(user: IUser) : boolean {
      return user && user.isEngineer;
    }

    public isHomeowner(user: IUser) : boolean {
      return user && user.isHomeowner;
    }

    public release() : void {
      localStorage.removeItem(this.userKey);
    }

    public captureUser() : Observable<IUser> {
      return new Observable(observer => {
        this.contactService.getContact(null).subscribe(data => {
          const user : IUser = {
            email: data.emailAddress1,
            fullName: data.fullName,
            needsProfileUpdate: !data.firstName || !data.lastName,
            id: data.id,
            isEngineer: data.isEngineer,
            isHomeowner: data.isHomeowner,
            isContractor: data.isContractor,
            mode: ''
          };

          observer.next(user);
          observer.complete();
        })
      });
    }
}

